var _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPay = function SvgPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 16"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(-779 -37)",
    fill: "#292A2C",
    fillRule: "evenodd",
    fontFamily: "LucidaGrande-Bold, Lucida Grande",
    fontSize: 16,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 778,
    y: 49
  }, "Pay"))));
};

export default SvgPay;